module.exports = __webpack_public_path__ + "static/app_bar_6-7c708f6c1e701107ecc6f3b39a936f62.png";